import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface ICartItem {
    id: number,
    name: string,
    price_sale: number,
    quantity: number
    type: string,
    parent_id: number,
    package_width: number,
    package_height: number,
    package_length: number,
    weight: number,
    unit_price: number,
    wholesale_upto?: number,
    wholesale_price?: {
        quantity: number,
        sale_price: number,
    }[],
}
export interface ICartState {
    cartInfo: ICartItem[],
}
const initialState: ICartState = {
    cartInfo: []
}

export const cartSlice = createSlice({
    name: 'cartInfo',
    initialState,
    reducers: {
        addProductToCart: (state, action: PayloadAction<ICartItem>) => {
            const index = state.cartInfo.findIndex(item => item.id === action.payload.id);
            if (index > -1 && state.cartInfo.length) {
                state.cartInfo[index].quantity = state.cartInfo[index].quantity + 1;
                return;
            }
            state.cartInfo = [...state.cartInfo, { ...action.payload, quantity: 1 }];
        },
        removeProductInCart: (state, action: PayloadAction<number>) => {
            const index = state.cartInfo.findIndex(item => item.id === action.payload);
            if (index > -1 && state.cartInfo[index].quantity > 1) {
                state.cartInfo[index].quantity = state.cartInfo[index].quantity - 1;
                return;
            }
            state.cartInfo = state.cartInfo.filter(item => item.id !== action.payload);
        },
        updateQuantityProductInCart: (state, action: PayloadAction<{ id: number, quantity: number }>) => {
            const index = state.cartInfo.findIndex(item => item.id === action.payload.id);
            if (index > -1) {
                state.cartInfo[index].quantity = action.payload.quantity;
                return;
            }
        },
        addProductToCartWithQuantity: (state, action: PayloadAction<{
            quantity: number,
            product: ICartItem
        }>) => {
            const index = state.cartInfo.findIndex(item => item.id === action.payload.product.id);
            if (index > -1) {
                state.cartInfo[index].quantity = state.cartInfo[index].quantity + action.payload.quantity;
                return;
            }
            state.cartInfo = [...state.cartInfo, {
                ...action.payload.product,
                quantity: action.payload.quantity,
            }]
        },
        clearProductInCart: (state, action: PayloadAction<{ id: number }>) => {
            state.cartInfo = state.cartInfo.filter(item => item.id !== action.payload.id);
        },
        clearCart: (state) => {
            state.cartInfo = [];
        }
    }
})
export const { addProductToCart, removeProductInCart, clearCart, updateQuantityProductInCart, clearProductInCart, addProductToCartWithQuantity } = cartSlice.actions;
export default cartSlice.reducer;